import { render, staticRenderFns } from "./SolicitudesExtraordinarios.vue?vue&type=template&id=37b688dd&"
import script from "./SolicitudesExtraordinarios.vue?vue&type=script&lang=ts&"
export * from "./SolicitudesExtraordinarios.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports